import Router from 'next/router';
import { transferTray } from '../../services/transfer-tray.service';
import { pickUpTransferredFiles } from '../../utils/pickup-transferred-files';
import { SessionFilesComponent } from './session-files/session-files.component';
import { RecentOnPageComponent } from './recent-on-page/recent-on-page.component';
import { getToolDisplayName } from '../../utils/filename-utils';
import React, { Component } from 'react';
import { container } from '../../context/module';
import { ReplaySubject, Subscription, interval } from 'rxjs';
import { PackageType, Packages } from '../../commons/commons';
import ContactUsModal from '../../components/ui/contact-us-modal/contact-us.modal';
import { lazyInject } from '../../context/module';
import { MetricsService } from '../../services/metrics.service';
import { MetricEventName } from '../../types/metric-events';
import { ConnectivityUtils } from '../../utils/connectivity.utils';
import { DropboxFile } from '../../models/dropbox-file';
import { FileUpload } from '../../models/file-upload';
import { GoogleDriveFile } from '../../models/google-drive-file';
import { Logger } from '../../models/logger';
import { UploadInProgressFile } from '../../models/upload-in-progress-file';
import { EnvironmentService } from '../../services/environment.service';
import { FileManagerService } from '../../services/file-manager.service';
import { FileProcessService } from '../../services/file-process.service';
import { FileUploadService } from '../../services/file-upload.service';
import { LoginService } from '../../services/login.service';
import { SpinnerService } from '../../services/spinner.service';
import { UIContext } from '../../services/ui-context';
import { UploadedFilesService } from '../../services/uploaded-files.service';
import { WebSocketService } from '../../services/websocket.service';
import { WindowService } from '../../services/window.service';
import { FileSelectEvent, FileUploadProps } from '../../types/file-upload.types';
import { PageData, RouteProps } from '../../types/route-types';
import { FromType, ProcessType, ToType, WebsocketResponse } from '../../types/types';
import { BrowserUtils } from '../../ui-utils/browser-utils';
import { getExtension } from '../../utils/file';
import { get, isEmpty, isEqual } from '../../utils/lodash-min';
import { reloadAfterExecute } from '../../utils/react.utils';
import { MotiveConfig } from '../../utils/request.utils';
import { RxUtils } from '../../utils/rx-utils';
import { untilDestroyed } from '../../utils/until-destroyed';
import { AdvancedOptionsSectionComponent } from '../ui/advanced-options-section/advanced-options-section.component';
import { ConvertOptionsContextV2, ConvertOptionsSummary } from "../convert-options-v2/convert-options.context";
import { GroupViewState, SelectableOptionViewState } from '../convert-options-v2/convert-options.view-states';
import styles from './file-convert.component.module.scss';
import { FileUploadManager } from './file-upload-manager';
import FileUploadComponent from './file-upload/file-upload.component';
import { ValidationBanner } from '../ui/validation-banner/validation-banner.component';
import { WorkflowSearchComponent } from './workflow-search.component';import { RejectedFile } from '../../services/file-validation.service';
import DropZoneComponent from './drop-zone/drop-zone.component';

interface FileConvertComponentState {
    fileWithMetadataList: UploadInProgressFile<DropboxFile | File | GoogleDriveFile>[],
    fileSelectedByUser: boolean,
    fileSelectBtnClickedByUser: boolean,
    fakeUploadInProgressFileForSelectedFiles: Array<UploadInProgressFile<any>>,
    sideMenuShown: boolean;
    showMainUploadButton: boolean;
    processButtonText?: string;
    rejectedFiles?: RejectedFile[];
    rejectedTotalFiles?: number;
}

import { FileProcessEditorComponent } from './file-process-editor.component';
import { isPerFileMergeType } from '../../utils/merge-type.utils';
import { mergeUploadInProgressLists } from '../../utils/options.utils';

/**
 * `belowToolAd` is handed in as an element rather than imported here on purpose -- see the
 * comment at its render site.
 */
type FileConvertProps = RouteProps & { belowToolAd?: any; aboveToolAd?: any };

export default class FileConvertComponent extends Component<FileConvertProps, FileConvertComponentState> {
    logger = Logger.getLogger('FileConvertComponent');

    editorRef = React.createRef<FileProcessEditorComponent>();

    private title: string;
    private description: string;
    private advancedOptionsAutoSelectDialogShown = false;
    public packageType: PackageType = null;
    public get isPaidUser() {
        return !!this.packageType;
    }
    public get isProUser() {
        return this.isPaidUser ? this.packageType === Packages.PACKAGE_TYPE_PRO : false;
    }
    public avMaxFileLimit = 10;
    public nonAVMaxFileLimit = 10;

    public processType: ProcessType;
    public fromType: Array<FromType>;
    public toType: ToType;
    public accept: string;
    public fileUploadBtnText: string = 'Select Files';
    public btnText: string;
    public selectedOutputExtension: any;
    public convertOptionsContextV2: ConvertOptionsContextV2;

    public convertSubscriber$: Subscription;
    private subscribersToClose: Subscription[] = [];
    public startConvertProcessTriggered = false;
    public convertProcessStartRequestProcessed = false;

    private hasFileUploads = false;

    effectiveMotives: MotiveConfig;
    // private fileUploadArray: FileUpload[];

    // @Output() 
    onSidePanelFileUploadsChange = new ReplaySubject<FileUpload[]>();

    fileUploadManager: FileUploadManager;

    sortableOptions = {
        onUpdate: (event: any) => {
            this.sortOrderChanged(event);
        },
    };


    wsConnected = true;

    get shouldShowLoading() {
        return this.state.fakeUploadInProgressFileForSelectedFiles.length > 0;
    }

    get getLoadingFileList() {
        return Array.from(this.state.fakeUploadInProgressFileForSelectedFiles);
    }

    @lazyInject(UIContext) private uiContext: UIContext;
    @lazyInject(MetricsService) private metricsService: MetricsService;
    @lazyInject(UploadedFilesService) private uploadedFilesService: UploadedFilesService;
    @lazyInject(WebSocketService) public websocketService: WebSocketService; // Template used this
    @lazyInject(FileProcessService) public fileProcessService: FileProcessService;
    @lazyInject(WindowService) public windowService: WindowService;
    @lazyInject(FileManagerService) private fileManagerService: FileManagerService;
    @lazyInject(SpinnerService) private spinnerService: SpinnerService;
    @lazyInject(EnvironmentService) private environmentService: EnvironmentService;
    @lazyInject(LoginService) private loginService: LoginService;
    @lazyInject(FileUploadService) private fileUploadService: FileUploadService;


    // sensors = useSensors(
    //     useSensor(PointerSensor),
    //     useSensor(KeyboardSensor, {
    //       coordinateGetter: sortableKeyboardCoordinates,
    //     })
    //   );

    readonly state: Readonly<FileConvertComponentState> = {
        fileWithMetadataList: [],
        fileSelectedByUser: false,
        fakeUploadInProgressFileForSelectedFiles: [],
        sideMenuShown: false,
        showMainUploadButton: true,
        fileSelectBtnClickedByUser: false,
    };
    constructor(props: RouteProps) {
        super(props);
        const wsStatus = this.websocketService.status.pipe(
            untilDestroyed(this),
        ).subscribe({
            next: () => {
                this.wsConnected = this.websocketService.isConnected() && this.websocketService.isServiceReady();
            }
        });
        this.subscribersToClose.push(wsStatus);

        this.convertOptionsContextV2 = ConvertOptionsContextV2.newContext(
            props.convertOptionsV2
        );
        this.convertOptionsContextV2.modelChangeObserver.pipe(untilDestroyed(this)).subscribe(() => {
            const text = this.getProcessButtonText();
            if (text !== this.state.processButtonText) this.setState({ processButtonText: text });
        });

        const userDetailsChangedSub = this.loginService.onUserDetailsChanged.subscribe({
            next: (userDetails) => {
                this.packageType = userDetails && userDetails.isPaidUser() ? userDetails.packageType : null;
                this.nonAVMaxFileLimit = this.packageType === Packages.PACKAGE_TYPE_PRO ? 25 :
                    (this.packageType === Packages.PACKAGE_TYPE_BASIC ? 10 : 5);
                this.avMaxFileLimit = this.packageType === Packages.PACKAGE_TYPE_PRO ? 25 :
                    (this.packageType === Packages.PACKAGE_TYPE_BASIC ? 10 : 5);
            }
        });
        this.subscribersToClose.push(userDetailsChangedSub);

        // const fileSelectedSub = this.fileUploadService.onFileSelected.subscribe({
        //     next: () => {
        //         this.fileSelectedByUser();
        //     }
        // });
        // this.subscribersToClose.push(fileSelectedSub);

        // const fileSelectBtnClickedSub = this.windowService.onFileSelectBtnClicked.subscribe({
        //     next: () => {
        //         this.fileSelectButtonClicked();
        //     }
        // });
        // this.subscribersToClose.push(fileSelectBtnClickedSub);


        this.processPageData(props.pageData);
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('pagehide', this.onPageHideAbandonment);
        }
        this.subscribersToClose.forEach(sub => {
            RxUtils.safeCloseSubscriber(sub);
        });
        this.fileUploadManager?.dispose();
    }

    /**
     * The measured form of the upload→convert loss (sweep P2): the page went away
     * while files sat staged and Convert was never pressed. sendBeacon survives
     * pagehide, so this is one of the few signals that can be sent from here.
     */
    private onPageHideAbandonment = () => {
        if (this.startConvertProcessTriggered) return;
        const staged = this.state.fileWithMetadataList?.length ?? 0;
        if (staged === 0) return;
        container.get(MetricsService).emit(MetricEventName.UPLOAD_ABANDONED, {
            page: this.props.path || '',
            fileCount: staged,
        });
    };

    private getProcessButtonText(): string {
        if (this.convertOptionsContextV2) {
            const summary = this.convertOptionsContextV2.getSummary() as any;
            if (isPerFileMergeType(summary?.mergeType)) return 'Convert';
        }
        return this.btnText || this.processType || 'Process';
    }

    private processPageData(value: PageData) {
        this.title = value.page_seo.title;
        this.description = value.page_seo.description && value.page_seo.description.replace(/\s+/g, ' ');
        this.processType = value.processType?.toLowerCase() as ProcessType;
        this.fromType = value.fromType?.map((type) => type.toLowerCase()) as FromType[];
        this.toType = value.toType?.toLowerCase() as ToType;
        this.accept = value.accept;
        this.btnText = value.btnText;
        this.fileUploadBtnText = value.file_uload_button_text
    }

    componentDidMount() {
        this.setState({
            fileSelectedByUser: false,
        });
        const fileReloadSub = this.uploadedFilesService.getOnRequestFileReuploadSubscriber().pipe(
            untilDestroyed(this),
        ).subscribe({
            next: (fileUpload: FileUpload) => {
                this.fileSelected({
                    files: fileUpload.file,
                } as any).catch(console.error);
                this.uploadedFilesService.removeFileFromFileList(fileUpload);
                this.forceUpdate();
            },
            error: (err) => {
                this.logger.error({ message: 'Failed to load PageData', error: err });
                this.forceUpdate();
            },
        });
        this.subscribersToClose.push(fileReloadSub);
        this.pickUpTransferredFiles();
        if (typeof window !== 'undefined') {
            window.addEventListener('pagehide', this.onPageHideAbandonment);
        }
    }

    private pickUpTransferredFiles() {
        pickUpTransferredFiles({
            acceptedExtensions: (this.props.pageData as any)?.acceptedExtensions,
            pageSlug: this.props.path,
            // source: 'handoff' — by the time these bytes reach the uploader they
            // are indistinguishable from a local pick, so the tag is the only way
            // FILE_SELECTED can tell us whether arrive-with-file is being used.
            stage: (files) => { this.fileSelected({ files, source: 'handoff' } as any).catch(console.error); },
        });
    }

    componentDidUpdate(prevProps: RouteProps, prevState: FileConvertComponentState) {
        this.updateUploadedFileExtensions();
    }

    private updateUploadedFileExtensions() {
        const extensions = this.state.fileWithMetadataList.map(metadata => getExtension(metadata.file.name).toLocaleLowerCase());
        const uniqueExtensions = Array.from(new Set(extensions));
        const currentExtensions = this.convertOptionsContextV2.getRootProperty('uploadedFileExtensions') as string[];
        if (isEmpty(uniqueExtensions)) {
            this.convertOptionsContextV2.unsetRootProperty('uploadedFileExtensions');
        }
        if (!isEqual(uniqueExtensions, currentExtensions)) {
            this.convertOptionsContextV2.setRootProperty('uploadedFileExtensions', uniqueExtensions);
            this.autoSelectCompressionOptions(uniqueExtensions);
        }
    }

    private autoSelectCompressionOptions(uniqueExtensions: string[]) {
        if (this.props.path.endsWith('compressor')) {
            if (uniqueExtensions.length == 1 && !this.advancedOptionsAutoSelectDialogShown) {
                const extensionGroupViewState = this.convertOptionsContextV2.findViewStateByPropertyName('toExtension');
                if (extensionGroupViewState) {
                    const extensionUpperCase = uniqueExtensions[0].toUpperCase();
                    const extensionNode = this.convertOptionsContextV2.findNode(extensionGroupViewState, (id) => {
                        return id.includes(extensionUpperCase);
                    });

                    if (extensionNode && extensionGroupViewState instanceof GroupViewState && extensionNode instanceof SelectableOptionViewState) {
                        if (extensionGroupViewState.selected != extensionNode) {
                            this.uiContext.showConfirmationWarningDialog(
                                `${extensionUpperCase} File Upload Detected`,
                                `Would you like to auto-select optimized settings for ${extensionUpperCase} files?`,
                                () => {
                                    extensionGroupViewState.updateValue(extensionNode);
                                    this.convertOptionsContextV2.emitModelChanged()
                                },
                            )
                            this.advancedOptionsAutoSelectDialogShown = true;
                        }
                    }
                }
            }
        }
    }

    /**
     * Called when files are added or removed in the editor
     */
    onEditorFilesChange(files: UploadInProgressFile<any>[]) {
        this.setState({
            fileWithMetadataList: files
        }, () => {
            this.updateUploadedFileExtensions();
            this.updateSidePanelFileUploads();
        });

        // Update hasFileUploads for UI state
        this.hasFileUploads = files.length > 0;

        if (this.fileUploadManager) {
            this.fileUploadManager.updateFileList(files);
        }
    }

    private populateTestImageForUpload() {
        this.setState({
            fileSelectedByUser: true,
            fileSelectBtnClickedByUser: true,
        });
        setTimeout(async () => {
            const response = await fetch("https://www.xconvert.com/img/xconvert/desktop/windows/screen2.png");
            // here image is url/location of image
            const blob = await response.blob();
            const file = new File([blob], 'image.png', { type: blob.type });
            const file1 = new File([blob], 'Long image name for testing.png', { type: blob.type });
            const file2 = new File([blob], 'This is another image. Little big longer than the previous.png', { type: blob.type });
            this.fileSelected({ files: [file, file1, file2] });
        }, 1000);
    }

    public async startConvertProcess() {
        if (this.hasProcessUploadedFiles() && this.canProcessUploadedFiles()) {
            if (!this.convertProcessStartRequestProcessed) {
                this.convertProcessStartRequestProcessed = true;
                this.stopConvertPolling();
                await this.convert().catch(console.error);
                this.convertProcessStartRequestProcessed = false;
                this.startConvertProcessTriggered = false;
            }
        }
    }

    private convertTimeoutId: any;
    private lastProgressSnapshot: Map<string, number> = new Map();

    public convertWhenReady() {
        if (!this.startConvertProcessTriggered) {
            if (this.hasProcessUploadedFiles()) {
                // Funnel spine (sweep P2): the convert click with its context —
                // how many files, and whether any option knob was touched first.
                const metrics = container.get(MetricsService);
                metrics.emit(MetricEventName.CONVERT_START, {
                    page: this.props.path || '',
                    fileCount: this.state.fileWithMetadataList?.length ?? 0,
                    optionsChanged: metrics.optionChangesThisPage,
                });
                if (this.canProcessUploadedFiles()) {
                    this.startConvertProcessTriggered = true;
                    this.startConvertProcess();
                    return;
                }
                this.startConvertProcessTriggered = true;
                this.convertSubscriber$ = interval(1000).subscribe({
                    next: () => {
                        this.startConvertProcess();
                        // Track progress snapshots
                        this.state.fileWithMetadataList.forEach(f => {
                            this.lastProgressSnapshot.set(f.uuid, f.progress);
                        });
                    },
                });
                this.scheduleUploadTimeout();
                this.uiContext.successToast(`File ${this.processType} will automatically start when upload complete!`, '', 10000);
            } else {
                this.uiContext.errorToast(`Please select files!`, '', false, false);
            }
        } else {
            if (this.canProcessUploadedFiles()) {
                this.startConvertProcess();
            } else {
                this.uiContext.successToast(`Process will start once all files are uploaded!`, '', 10000);
            }
        }
        this.forceUpdate();
    }

    private scheduleUploadTimeout() {
        this.convertTimeoutId = setTimeout(() => {
            if (!this.startConvertProcessTriggered || this.convertProcessStartRequestProcessed) return;

            // If any file made progress since last snapshot, reschedule
            const hasProgress = this.state.fileWithMetadataList.some(f =>
                !f.getComplete() && !f.error && f.progress > (this.lastProgressSnapshot.get(f.uuid) || 0)
            );
            if (hasProgress) {
                this.scheduleUploadTimeout();
                return;
            }

            this.stopConvertPolling();
            this.startConvertProcessTriggered = false;
            const stuckFiles = this.state.fileWithMetadataList
                .filter(f => !f.getComplete() && !f.error)
                .map(f => (f.file as any)?.name || 'unknown')
                .join(', ');
            if (!stuckFiles) return; // All files either completed or errored

            if (!ConnectivityUtils.isOnline()) {
                this.uiContext.showErrorDialog({
                    title: 'Connection Lost',
                    text: 'You appear to be offline. Please check your connection and try again.',
                    confirmButtonText: 'Retry',
                    successCallback: () => this.convertWhenReady(),
                });
            } else {
                this.uiContext.showErrorDialog({
                    title: 'Upload Timeout',
                    text: `Some files are still uploading: ${stuckFiles}. Please retry uploading them or remove them to continue.`,
                    confirmButtonText: 'Retry',
                    successCallback: () => this.convertWhenReady(),
                });
            }
            this.forceUpdate();
        }, 120000);
    }

    /** Stop the convert polling interval and timeout without resetting state flags. */
    private stopConvertPolling() {
        RxUtils.safeCloseSubscriber(this.convertSubscriber$);
        if (this.convertTimeoutId) { clearTimeout(this.convertTimeoutId); this.convertTimeoutId = null; }
    }

    @reloadAfterExecute()
    private resetProcessOnUploadCompleteProcedure() {
        this.stopConvertPolling();
        this.startConvertProcessTriggered = false;
        this.convertProcessStartRequestProcessed = false;
    }

    public updateProcessProbedDataFn() {
        const that = this;
        return async (probeDuration: number) => {
            // Delegated to FileProcessEditorComponent internally for now
            if (that.editorRef.current && that.editorRef.current.fileProcessService) {
                // We might need to expose a method on editor if specific logic is needed
                // For now, returning void/promise as placeholder if logic is fully internal to editor
            }
        };
    }

    public async convert() {
        if (this.editorRef.current) {
            await this.editorRef.current.startConversion();
        }
    }

    hasProcessUploadedFiles() {
        return this.state.fileWithMetadataList.length > 0;
    }

    canProcessUploadedFiles() {
        return this.hasProcessUploadedFiles() && this.state.fileWithMetadataList.every(f => f.getComplete());
    }

    async fileSelected(event: FileSelectEvent) {
        if (!this.fileUploadManager) {
            // IMPORTANT: This need to be re-initialized if moved to SPA
            this.fileUploadManager = new FileUploadManager(
                this.state.fakeUploadInProgressFileForSelectedFiles,
                this.state.fileWithMetadataList,
                this.props,
                this.logger,
                this.fromType,
                this.toType,
                () => {
                    this.forceUpdate();
                },
                () => {
                    this.updateSidePanelFileUploads();
                    this.forceUpdate();
                },
            );
            this.fileUploadManager.fileListChanged.subscribe((fileListChangeEvent) => {
                this.hasFileUploads = get(fileListChangeEvent, 'fileWithMetadataList', []).length > 0;
                if (this.editorRef.current) {
                    this.editorRef.current.updateFiles(
                        get(fileListChangeEvent, 'fileWithMetadataList', [])
                    );
                }
                this.forceUpdate();
            });
            this.fileUploadManager.validationResult.subscribe((result) => {
                this.setState({ rejectedFiles: result.rejected, rejectedTotalFiles: result.totalFiles });
            });
        }
        await this.fileUploadManager.fileSelected(event);

        // Remember what they picked so other tools can offer it back (T6.2). Fire-and-forget:
        // a convenience riding along with an upload must never delay or break it.
        try {
            const picked = Array.from((event as any)?.files || []) as File[];
            if (picked.length) {
                transferTray.remember(
                    picked,
                    this.props.path || '',
                    getToolDisplayName(this.props.pageData, this.props.path),
                ).catch(() => { /* best-effort */ });
            }
        } catch { /* best-effort */ }
    }

    sortOrderChanged(e: any) {
        // Handled by Editor
    }

    updateSidePanelFileUploads() {
        // No-op or implementation if needed
    }

    decodeData(wsData: WebsocketResponse) {
        if (wsData.dataType === 'notification') {
            return wsData.data;
        } else if (wsData.dataType === 'ratio') {
            return wsData.data;
        } else if (wsData.dataType === 'percentage') {
            return parseFloat(wsData.data).toFixed(2);
        } else {
            return 'Waiting for server to reply';
        }
    }

    showContactUs(e: MouseEvent) {
        e.preventDefault();
        ContactUsModal.show({});
    }

    getFileConverts() {
        const hasStagedFiles = (this.state.fileWithMetadataList || []).length > 0
            || (this.state.fakeUploadInProgressFileForSelectedFiles || []).length > 0;
        return <div className={`${styles['sortable-container']} container-fluid g-0`}>
            {/*
              * Inside the container, not above it. This element reserves min-height 100px for
              * the staged-file list and that space is empty on a first visit, so a 320x100 unit
              * here costs the uploader nothing -- rendering it above instead moved the drop zone
              * from y=363 to y=483. It gives the room straight back the moment a file is staged.
              */}
            {!hasStagedFiles && this.props.aboveToolAd}
            <FileProcessEditorComponent
                ref={this.editorRef}
                initialFiles={this.state.fileWithMetadataList}
                convertOptionsContext={this.convertOptionsContextV2}
                toType={this.toType}
                fromType={this.fromType as any}
                processType={this.processType}
                pageData={this.props.pageData}
                onFilesChange={(files) => this.onEditorFilesChange(files)}
                onConversionSuccess={() => this.onConversionSuccess()}
            />
        </div>
    }

    private onConversionSuccess() {
        Router.push('/downloads');
    }

    private isXConvert() {
        return this.environmentService && this.environmentService.isXConvert();
    }

    private toggleSideMenu() {
        this.setState({
            sideMenuShown: !this.state.sideMenuShown,
        });
    }

    private hideMainUploadButton() {
        if (this.state.showMainUploadButton) {
            this.setState({
                showMainUploadButton: !this.state.showMainUploadButton,
            });

            setTimeout(() => {
                BrowserUtils.runIfWindowExists(() => {
                    if (window.innerWidth < 500) {
                        this.toggleSideMenu();
                    }
                });
            })
        }
    }

    handleDragEnd(event) {
        const { active, over } = event;

        if (active.id !== over.id) {
            //   setItems((items) => {
            //     const oldIndex = items.indexOf(active.id);
            //     const newIndex = items.indexOf(over.id);

            //     return arrayMove(items, oldIndex, newIndex);
            //   });
        }
    }

    /**
     * "Files you used recently" (T6.2/T6.4).
     *
     * Lives here rather than on the page component because picking a file has to go through
     * `fileSelected` — the same path a drop takes — so upload, probing, option defaults and the
     * file card all behave identically whether the file came from the device or the tray.
     */
    /** Rows the re-run section will show, so one shared trigger can count both sections. */
    private reRunCount = 0;

    getSessionFiles() {
        const reRun = <RecentOnPageComponent
            processType={this.props.pageData?.processType}
            toType={this.props.pageData?.toType}
            uniqueProcessType={(this.props.pageData as any)?.uniqueProcessType}
            toolName={getToolDisplayName(this.props.pageData, this.props.path)}
            pageSlug={this.props.path}
            onCount={(n) => { if (n !== this.reRunCount) { this.reRunCount = n; this.forceUpdate(); } }}
        />;
        return <SessionFilesComponent
            reRunSection={reRun}
            reRunCount={this.reRunCount}
            acceptedExtensions={this.props.pageData?.acceptedExtensions || []}
            pageSlug={this.props.path}
            toolName={getToolDisplayName(this.props.pageData, this.props.path)}
            pageData={this.props.pageData}
            stagedKeys={(this.state.fileWithMetadataList || [])
                .map(f => `${f?.file?.name}:${f?.file?.size}`)}
            onPick={(files) => { this.fileSelected({ files, source: 'session' } as any).catch(console.error); }}
        />;
    }

    /**
     * The misrouted-files banner, rendered identically whether or not valid files are staged.
     *
     * It used to be two copies of the same JSX in the two branches of render(), so every change
     * had to be made twice or the two states silently diverged.
     */
    getValidationBanner() {
        if (!(this.state.rejectedFiles?.length > 0)) return null;
        return <ValidationBanner
            rejectedFiles={this.state.rejectedFiles}
            totalFiles={this.state.rejectedTotalFiles || 0}
            toolName={getToolDisplayName(this.props.pageData, this.props.path)}
            fromSlug={this.props.path}
            acceptedExtensions={this.props.pageData?.acceptedExtensions || []}
            // Only fires once the user has removed the last pending row. Dismissing the banner
            // keeps the rows, so it must not reach here.
            onDismiss={() => this.setState({ rejectedFiles: [], rejectedTotalFiles: 0 })}
        />;
    }

    render() {
        const extraPropsV2 = {
            convertOptionsContext: this.convertOptionsContextV2,
            // NOT a plain concat: the fake placeholder lives until upload COMPLETES but
            // the real entry exists from upload START — a raw concat lists every file
            // twice for the whole upload (visible in the target-size notes).
            uploadInProgressFiles: mergeUploadInProgressLists(
                this.state.fakeUploadInProgressFileForSelectedFiles,
                this.state.fileWithMetadataList,
            ),
            onOptionChange: (data: ConvertOptionsSummary) => {
                // Remove following
                const summary = this.convertOptionsContextV2.getSummary();
                console.log(summary);
                if (typeof window !== 'undefined') {
                    const key = Object.entries(summary)
                        .filter(([k]) => k !== 'uploadedFileExtensions')
                        .map(([k, v]) => `${k}=${v}`)
                        .join('_')
                        .replace(/[^a-zA-Z0-9_=\-\.]/g, '-');
                    (window as any).__uniqueSummaries = (window as any).__uniqueSummaries || {};
                    (window as any).__uniqueSummaries[key] = summary;
                }
            },
        };
        const fileUploadProps: FileUploadProps = {
            acceptedFileTypes: this.accept || '*',
            uploadBtnText: this.fileUploadBtnText || 'Add Files',
            fileSelectButtonClicked: () => {
                // Skipped
            },
            fileSelected: (ev) => {
                this.fileSelected(ev).catch(console.error);
                this.hideMainUploadButton();
            },
        };


        if (true) {
            const hasFiles = this.state.fileWithMetadataList.length > 0 ||
                this.state.fakeUploadInProgressFileForSelectedFiles.length > 0;

            return <>
                <div className='mt-2'>
                    <WorkflowSearchComponent />

                    {
                        this.getFileConverts()
                    }

                    {!hasFiles && (
                        <div className='row' key={'file-convert-drop-zone'}>
                            <div className='col-12'>
                                {this.getValidationBanner()}
                                <DropZoneComponent
                                    acceptedExtensions={this.props.pageData?.acceptedExtensions}
                                    fileUploadProps={fileUploadProps}
                                />
                                {/*
                                  * Immediately under the drop zone, because that is where the
                                  * question "which file?" is asked. It was previously last in
                                  * the tool, below the Advanced Options accordion -- measured on
                                  * QA at 412px wide it rendered at y=1,919 against a drop zone
                                  * at y=363, so it was two screens below the only control it
                                  * relates to. A file picker shortcut nobody scrolls to is not
                                  * a feature.
                                  *
                                  * It arrives after hydration, so content below it shifts. The
                                  * drop zone is above it and does not move, which is the part
                                  * that matters -- the user's target stays put.
                                  */}
                                {this.getSessionFiles()}
                            </div>
                        </div>
                    )}

                    {hasFiles && (
                        <div className='row' key={'file-convert-file-upload-container'}>
                            <div className='col-12'>
                                {this.getValidationBanner()}
                                {/*
                                  * Still here once files are staged. Hiding it after the first
                                  * pick stranded anyone adding a second file from the same
                                  * batch -- the list is how they get at it without another trip
                                  * to the device. Rows already staged say "Added" instead of
                                  * disappearing, so nothing jumps and they can see it went in.
                                  */}
                                {this.getSessionFiles()}
                                <div className="card border-0">
                                    <div className="card-body p-0 bg-pattern">
                                        <div className={`row`}>
                                            <div className='col-sm-12 col-md-5'>
                                                <div className={`${styles['file-upload-btn']}`}>
                                                    <FileUploadComponent {...fileUploadProps} shouldDisplayBtnsAsPrimary={true}></FileUploadComponent>
                                                </div>
                                            </div>
                                            <div className='col-sm-12 col-md-3'></div>
                                            <div className='col-sm-12 col-md-4'>
                                                <button className={`btn btn-lg btn-primary square-edges pull-right w-100 ${styles['process-btn']}`}
                                                    onClick={() => this.convertWhenReady()}
                                                    data-jkey="process-btn">
                                                    {
                                                        this.startConvertProcessTriggered ?
                                                            'Loading...' : <span>{this.state.processButtonText || this.getProcessButtonText()}
                                                                <img width={"16px"} height={"16px"}
                                                                    className={`color-invert ${styles['process-btn-icon']}`}
                                                                    src="/icons/svg/arrow-right-short-shaft.svg"
                                                                    alt='Start'
                                                                /></span>
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/*
                      * Directly after the uploader, before the Advanced Options accordion.
                      *
                      * Passed in rather than imported: MotiveComponent pulls the inversify
                      * container, and adding that edge to this file -- which sits in the upload
                      * path's import graph -- crashed the webpack build with a module-eval
                      * error that tsc and jest both pass. The page owns the ad; this component
                      * owns where it goes.
                      * docs/proposed/AD_PLACEMENT_DESIGN.md 9
                      */}
                    {this.props.belowToolAd}

                    <div className="row">
                        <div className='col-12 mt-4'>
                            <AdvancedOptionsSectionComponent
                                convertOptionsContext={this.convertOptionsContextV2}
                                uploadInProgressFiles={extraPropsV2.uploadInProgressFiles}
                                onOptionChange={extraPropsV2.onOptionChange}
                                path={this.props.path}
                            />
                        </div>
                    </div>

                </div>
            </>
        }
    }
}
